import { SellerType } from '@kijiji/generated/graphql-types'

export const isCommercialUserId = (userId: string): boolean => {
  const isCommercial = userId.startsWith(`${SellerType.Commercial}_`)
  return isCommercial
}
